import type { Messages } from '@/i18n/types';

export const en: Messages = {
  'lang.label': 'Language',

  'nav.primary': 'Primary',
  'nav.about': 'About',
  'nav.features': 'Features',
  'nav.owners': 'For owners',
  'nav.download': 'Download',
  'nav.downloadCta': 'Download the app',
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',
  'nav.listStore': 'List your store',
  'nav.stats': 'By the numbers',
  'nav.faq': 'FAQ',

  'hero.headline': 'Find the right quán nhậu — tonight.',
  'hero.sub':
    'Open seats on the map, nearby spots, local tweets, and messages when you want company at the table.',
  'hero.ageNote': 'Drinking under age 18 is prohibited by law.',
  'hero.phoneAlt': 'Nhậu Đee app home screen showing the map search',

  'store.appStoreKicker': 'Download on the',
  'store.appStoreName': 'App Store',
  'store.appStoreAria': 'Download on the App Store',
  'store.playKicker': 'Get it on',
  'store.playName': 'Google Play',
  'store.playAria': 'Get it on Google Play',

  'about.title': 'A better way to find a night out',
  'about.body':
    'Nhậu Đee helps you find lively Vietnamese drinking spots with seats tonight—map filters, nearby shop lists with photos, guest tweets from the neighborhood, and messages when you want friends at the table.',

  'features.eyebrow': 'What you can do',
  'features.title': 'Everything you need for a good night out',
  'features.summary.01': 'Map search',
  'features.summary.02': 'Nearby',
  'features.summary.03': 'Messages',
  'features.summary.04': 'Tweets',
  'features.01.title': 'Search the map for quán nhậu',
  'features.01.body':
    'Explore the map with tonight’s vacancies and nearby filters—then open shops with seats available today.',
  'features.01.phoneAlt': 'Map search for drinking spots',
  'features.02.title': 'Browse nearby shops',
  'features.02.body':
    'Scroll a photo list of places near you, with distance and address, so you can pick a spot without walking in blind.',
  'features.02.phoneAlt': 'Nearby shop list',
  'features.03.title': 'Messages & Cheers',
  'features.03.body':
    'When you want company at the table, check Matches, chats, and Cheers—or see premium plans if you’re just getting started.',
  'features.03.phoneAlt': 'Messages and Cheers screen',
  'features.04.title': 'Read local tweets',
  'features.04.body':
    'Follow guest posts and ratings about shops nearby—filter by All, Shops, Users, or Diary to find what’s worth trying tonight.',
  'features.04.phoneAlt': 'Tweets feed',

  'pickup.tag': 'Tweets',
  'pickup.title': 'Real voices from the table',
  'pickup.body':
    'Guests share short reviews and tips about dishes, waits, and the vibe—so your next stop feels a little more familiar.',
  'pickup.imgAlt': 'Night drinking spot with cold beer and grilled food',

  'stats.eyebrow': 'Nhậu Đee in numbers',
  'stats.title': 'A growing map of quán nhậu',
  'stats.shops': 'Listed shops',
  'stats.shopsValue': 'TODO',
  'stats.areas': 'Coverage',
  'stats.areasValue': 'TODO',
  'stats.users': 'Users',
  'stats.usersValue': 'TODO',
  'stats.note': '*Figures are placeholders and will be updated at launch.',

  'safety.eyebrow': 'Safety',
  'safety.title': 'How we think about drinking with someone',
  'safety.body': 'Messages and Cheers are designed to be enjoyable and safer to use.',
  'safety.1.title': 'Identity checks',
  'safety.1.body': 'Verification flows help reduce impersonation risk.',
  'safety.2.title': 'Report & block',
  'safety.2.body': 'Report or block anyone who makes you uncomfortable. Our team reviews reports.',
  'safety.3.title': 'Age checks',
  'safety.3.body': 'Because this service involves drinking, we check age-related eligibility (18+).',

  'faq.eyebrow': 'FAQ',
  'faq.title': 'Frequently asked questions',
  'faq.1.q': 'Is there a fee?',
  'faq.1.a':
    'Core search, lists, and reading tweets are free. Some messaging/Cheers features may require Premium—see plans in the app.',
  'faq.2.q': 'Can I really find open seats tonight?',
  'faq.2.a':
    'Yes—use vacancy and nearby signals. Shop status can change, so check the latest vacancy info in the app.',
  'faq.3.q': 'What about safety and reporting?',
  'faq.3.a':
    'When meeting someone, you can report and block. Contact us in-app if something feels wrong.',
  'faq.4.q': 'How do shops get listed?',
  'faq.4.a':
    'Owners can start free from the owner portal—share vacancies, posts, menus, and staff intros.',

  'links.contact': 'Contact',
  'links.privacy': 'Privacy policy',
  'links.terms': 'Terms of use',
  'links.help': 'Help',

  'owners.eyebrow': 'For restaurant owners',
  'owners.title': 'Reach guests looking for a table tonight',
  'owners.body':
    'List your store, share tonight’s availability, post updates, and introduce your menu and staff—free to get started.',
  'owners.cta': 'Open the owner portal',
  'owners.signIn': 'Already have an account? Sign in',

  'cta.title': 'Start your next night out with Nhậu Đee',
  'cta.sub': 'Download the app and find a spot that feels right—tonight.',
  'cta.ageNote': 'Drinking under age 18 is prohibited by law.',

  'footer.inquiry': 'Inquiry',
  'footer.social': 'Social',
  'footer.about': 'About',
  'footer.owners': 'Owners',
  'footer.help': 'Help',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.company': 'Company',
  'footer.tokusho': 'Legal notice',
  'footer.age': 'Drinking under age 18 is prohibited by law.',
  'footer.facebook': 'Facebook',
  'footer.instagram': 'Instagram',
  'footer.x': 'X',
};
